export type TMicroRoutesOptions = {
  /**
   * base server uri
   */
  server: string;
  /**
   * digest token to authorize api calls
   */
  token: string;
};

export class MicroRoutes {
  static createRoutes(options: TMicroRoutesOptions) {
    const configuration = {
      view: {
        configuration: {
          account: {
            user_mode: 'student'
          },
          endpoints: {
            host: {
              application_name: 'sgd',
              server: options.server
            },
            authorization: {
              type: 'digest',
              token: options.token
            }
          }
        }
      }
    };

    const micro_interlink = [
      {
        configuration,
        id: 'micro_sgd_resource',
        location_uri: '/resources',
        resource_uri: './b073051cd2664d36/micros/nav/resources/bin',
        source_uri: [
          './b073051cd2664d36/micros/nav/resources/bin/index.json',
          './b073051cd2664d36/micros/nav/resources/bin/index.css'
        ]
      },
      {
        configuration,
        id: 'micro_sgd_financial_planner',
        location_uri: '/fp',
        resource_uri: './b073051cd2664d36/micros/nav/financial-planner/resources',
        source_uri: [
          './b073051cd2664d36/micros/nav/financial-planner/bin/index.json',
          './b073051cd2664d36/micros/nav/financial-planner/bin/index.css'
        ]
      },
      {
        configuration,
        id: 'micro_sgd_survey_home',
        location_uri: '/survey_home',
        resource_uri: './b073051cd2664d36/micros/nav/survey-home/resources',
        source_uri: [
          './b073051cd2664d36/micros/nav/survey-home/bin/index.json',
          './b073051cd2664d36/micros/nav/survey-home/bin/index.css'
        ]
      },
      {
        configuration,
        id: 'micro_sgd_calendar',
        location_uri: '/calendar',
        resource_uri: './b073051cd2664d36/micros/nav/calendar/resources',
        source_uri: [
          './b073051cd2664d36/micros/nav/calendar/bin/index',
          './b073051cd2664d36/micros/nav/calendar/bin/index.css'
        ]
      },
      {
        configuration,
        id: 'micro_sgd_journeys',
        location_uri: '/events',
        resource_uri: './b073051cd2664d36/micros/nav/student-journeys/resources',
        source_uri: [
          './b073051cd2664d36/micros/nav/student-journeys/bin/index',
          './b073051cd2664d36/micros/nav/student-journeys/bin/index.css'
        ]
      },
      {
        configuration,
        id: 'micro_nav_as3',
        location_uri: '/as3',
        resource_uri: './b073051cd2664d36/micros/nav/as3/resources',
        source_uri: [
          './b073051cd2664d36/micros/nav/as3/bin/index',
          './b073051cd2664d36/micros/nav/as3/bin/index.css'
        ]
      },
      {
        configuration,
        id: 'micro_nav_events_checkin',
        location_uri: '/event-campaigns',
        resource_uri: './b073051cd2664d36/micros/nav/events-checkin/resources',
        source_uri: [
          './b073051cd2664d36/micros/nav/events-checkin/bin/index',
          './b073051cd2664d36/micros/nav/events-checkin/bin/index.css'
        ]
      }
    ];

    const routes = [
      {
        uri: '/resources/*',
        layout_scheme: 'main',
        title: 'Resources',
        marker: '/micro/resources',
        regions: [
          {
            region: 'main',
            view_preloaded: 'micro_sgd_resource'
          }
        ]
      },
      {
        uri: '/calendar/*',
        layout_scheme: 'main',
        title: 'Calendar | Navigate360',
        marker: '/micro/calendar',
        regions: [
          {
            region: 'main',
            view_preloaded: 'micro_sgd_calendar'
          }
        ]
      },
      {
        uri: '/fp/*',
        layout_scheme: 'main',
        title: 'Financial Planner | Navigate360',
        marker: '/micro/fp',
        regions: [
          {
            region: 'main',
            view_preloaded: 'micro_sgd_financial_planner'
          }
        ]
      },
      {
        uri: '/survey_home/*',
        layout_scheme: 'main',
        title: 'Survey Home | Navigate360',
        marker: '/micro/survey_home',
        regions: [
          {
            region: 'main',
            view_preloaded: 'micro_sgd_survey_home'
          }
        ]
      },
      {
        uri: '/events/*',
        layout_scheme: 'main',
        title: 'Journeys | Navigate360',
        marker: '/micro/journeys',
        regions: [
          {
            region: 'main',
            view_preloaded: 'micro_sgd_journeys'
          }
        ]
      },
      {
        uri: '/as3/*',
        layout_scheme: 'main',
        title: 'Appointment Scheduling | Navigate360',
        marker: '/micro/as3',
        regions: [
          {
            region: 'main',
            view_preloaded: 'micro_nav_as3'
          }
        ]
      },
      {
        uri: '/event-campaigns/*',
        layout_scheme: 'main',
        title: 'Events Check-In | Navigate360',
        regions: [
          {
            region: 'main',
            view_preloaded: 'micro_nav_events_checkin'
          }
        ]
      },
      {
        uri: '/kbi',
        layout_scheme: 'main',
        title: 'Knowledge Bot | Navigate360',
        regions: [
          {
            region: 'main',
            view_tag: 'eab-nav-knowledge-bot',
            on_enter: 'on_enter -> /kbi',
            properties: {
              image: './b073051cd2664d36/res/eab-bot-logo.png',
              heading: 'Knowledge Bot',
              placeholder: 'Ask me a question',
              uri: 'wss://-- ctm endpoint --',
              ctmWs: {
                endpoint_uri: '/api/v1/core/retrieve_endpoint/?service_key=navai&endpoint_name=ws',
                endpoint_token: '/api/v1/core/client_jwt/',
                uri_suffix: '1'
              }
            }
          }
        ]
      }
    ];

    return {
      uri: '/my/host',
      on_enter: 'my_host -> on_enter',
      micro_interlink,
      routes
    };
  }
}



// WEBPACK FOOTER //
// ./app/lib/host/services/micro_routes.ts